<div class="full-screen-height-page-banner" fxLayout="column" fxLayoutGap="20px">
  <div fxLayout="row" fxLayoutAlign="space-between center" fxFlexOffset="20px">
    <div fxLayout="row" fxLayoutGap="15px">
      <div class="subtitle-default">Showcase</div>
    </div>
  </div>

  <app-image-grid [imageFiles]="leaseImageFiles"
                  [hasMoreImagesToLoad]="hasMoreImagesToLoad"
                  [isLoading]="isLoading"
                  [allowDelete]="true"
                  [allowAdd]="true"
                  [allowDownload]="true"
                  [filePrefix]="'showcase_lease'"
                  (addImage)="addImage()"
                  (deleteImage)="removeDocumentFromLease($event)"
                  (loadMoreImages)="loadMoreImages()"
  ></app-image-grid>
</div>
